import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SkeletonFill = ({ isStatic = false }) => (
  <div
    className={classNames('ws-ui-skeleton-fill', {
      'ws-ui-skeleton-fill--static': isStatic,
    })}
  />
);

SkeletonFill.propTypes = {
  isStatic: PropTypes.bool,
};

export default SkeletonFill;
